import React, { useState, useEffect } from 'react';
import { UseFormMethods, useForm } from 'react-hook-form';

interface IRHFTextAreaProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label?: string;
    name: string;
    disabled?: boolean;
    rules?: unknown;
    style?: React.CSSProperties;
    bodyStyle?: React.CSSProperties;
    rows?: number;
    defaultValue?: string;
    isRequired?: boolean;
    clearOnFirstClick?: boolean;
    maxLength?: number;
    setValue?: ReturnType<typeof useForm>['setValue'];

    onChange?: (e: React.FormEvent<HTMLTextAreaElement>) => void;
}

const RHFTextArea = (props: IRHFTextAreaProps) => {
    const defaultTextAreaContent = props?.defaultValue ? props?.defaultValue : '';
    const [cleared, setCleared] = useState(false);

    useEffect(() => {
        setCleared(false);
    }, [props.defaultValue]);

    const handleClick = (elem: HTMLTextAreaElement) => {
        if (props?.clearOnFirstClick && props?.setValue && !cleared && elem.value === defaultTextAreaContent) {
            props.setValue(props.name, '');
            setCleared(true);
        }
    };

    return (
        <div className="form-field" style={props.bodyStyle}>
            {props.label && <label htmlFor={props.name}>
                {props.label}
                {!!props.isRequired && <span style={{ color: 'red' }}>*</span>}
            </label>}
            {props.label && <br />}
            {props.maxLength && 
                <textarea
                    id="rhf-textarea"
                    name={props.name}
                    style={
                        !!props.disabled
                            ? { cursor: 'not-allowed', width: '100%', height: '20rem', resize: 'none' }
                            : props.style
                            ? props.style
                            : { width: '100%', height: '20rem' }
                    }
                    ref={props.register ? props.register(props.rules) : null}
                    className={`field ${props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) ? 'error-field' : ''}`}
                    rows={props.rows ? props.rows : 5}
                    defaultValue={props.defaultValue ? props.defaultValue : ''}
                    onChange={props?.onChange}
                    onClick={(elem) => handleClick(elem.currentTarget)}
                    disabled={props?.disabled}
                    maxLength={props.maxLength}
                />
            }
            {!props.maxLength && 
                <textarea
                    id="rhf-textarea"
                    name={props.name}
                    style={
                        !!props.disabled
                            ? { cursor: 'not-allowed', width: '100%', height: '20rem', resize: 'none' }
                            : props.style
                            ? props.style
                            : { width: '100%', height: '20rem' }
                    }
                    ref={props.register ? props.register(props.rules) : null}
                    className={`field ${props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) ? 'error-field' : ''}`}
                    rows={props.rows ? props.rows : 5}
                    defaultValue={props.defaultValue ? props.defaultValue : ''}
                    onChange={props?.onChange}
                    onClick={(elem) => handleClick(elem.currentTarget)}
                    disabled={props?.disabled}
                />
            }

            <br />
            {props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) && (
                <p>{props.name.split('.')?.reduce((o, i) => o[i], props.errors)?.message}</p>
            )}
        </div>
    );
};

export default RHFTextArea;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFTextArea.tsx